export const SET_KPIS_LOADED = "SET_KPIS_LOADED";

export const setKpisLoaded = (kpisLoaded: boolean) => {
  return {
    kpisLoaded,
    type: SET_KPIS_LOADED
  };
};
